import { useDeviceType } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { EBanners } from '../../../constants/banners';
import { selectMapBounds } from '../../../selectors/mapBounds';
import { selectParentRegionId } from '../../../selectors/parentRegionId';
import { selectJsonQuery } from '../../../selectors/results';
import { isFSKBannerAvailable } from '../../../utils/bannerPackages';
import { useApplicationContext } from '../../ApplicationContext';

export function useGetFskBanner(proPlusBannerType: EBanners.ProPlus | null): EBanners | null {
  const deviceType = useDeviceType();
  const jsonQuery = useSelector(selectJsonQuery);
  const parentRegionId = useSelector(selectParentRegionId);
  const { zoom } = useSelector(selectMapBounds);
  const isDesktop = deviceType === 'desktop';
  const { config } = useApplicationContext();

  // Adfox-баннер живёт в отдельном слоте (AdfoxSpecialProjectContainer)
  // и при включённом флаге полностью заменяет собой ФСК-промо.
  const adfoxEnabled = config.get<boolean>('mapSearchFrontend.AdfoxMapBanner.Enabled') || false;

  if (adfoxEnabled) {
    return null;
  }

  // Отображать ли фск баннер в качестве заглушки, когда нет промо баннеров ЖК
  const isShowWithPromoBannerOnMobile = !proPlusBannerType && !isDesktop;

  const isFSKAvailable = isFSKBannerAvailable({
    jsonQuery,
    deviceType,
    parentRegionId,
    isShowWithPromoBannerOnMobile,
    zoom,
  });

  if (isFSKAvailable) {
    return EBanners.Fsk;
  }

  return null;
}
